import React, { useState, useEffect } from "react";
import axios from "axios";
import PromoFile from "../../SuperStar/PromoVideo/PromoFile";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import Pending from "../../../assets/Icon/pending.png";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";
const PendingPromoVideo = () => {
  const [loading, setLoading] = useState(true);
  const [event, setEvents] = useState([]);
  const [pending, setPending] = useState("");

  const PendingVideos = () => {
    axios.get(`/api/admin/promoVideo/pending`).then((res) => {
      if (res.data.status === 200) {
        setEvents(res.data.promoVideos);
      }
      setLoading(false);
    });
  };
  useEffect(() => {
    PendingVideos();
  }, []);

  useEffect(() => {
    axios.get(`/api/admin/promoVideoCount`).then((res) => {
      if (res.status === 200) {
        setPending(res.data.pendingTotal);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title={"Pending Promo Video"}
        image={Pending}
        count={pending}
      />
      {loading === true ? (
        <LoaderPost />
      ) : (
        <PromoFile
          data={event}
          urlLink={`/superstar-admin/promoVideo/details`}
        />
      )}
    </>
  );
};

export default PendingPromoVideo;
